import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { ClickImageState } from './click-image-interfaces';

@injectable()
export class ClickImageStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<ClickImageState> {

  key = { id: 33, name: { ns: 'interaction-suspend-data', name: 'click-image' }, format: 'protobuf' }

  serialize(data: ClickImageState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new ClickImageStateProtoMessage({
      states: data.states,
      touched: data.touched,
    })

    return ProtobufSerializer.serialize<ClickImageStateProtoMessage>(message, ClickImageStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<ClickImageState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<ClickImageStateProtoMessage>(content, ClickImageStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: ClickImageState = {
      states: message.states,
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@Type.d('ClickImageStateProtoMessage')
class ClickImageStateProtoMessage extends Message<ClickImageStateProtoMessage> {
  @Field.d(1, 'bool', 'repeated')
  states: boolean[];

  @Field.d(2, 'bool', 'repeated')
  touched: boolean[];
}
